
import { throwError as observableThrowError } from 'rxjs';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { defaults } from '../defaults';
import { BpConfigService } from '../config/bp-config.service';


@Injectable()
export class BasedataService {

  constructor(private configService: BpConfigService) {}

  protected getHeaders(forUpload: boolean = false): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    if (forUpload) {
      headers = defaults.getDefaultUploadHeaders();
    } else {
      headers = defaults.getDefaultHeaders();
    }
    return headers;
  }

  protected getFullUrl(appRelativeEndpoint: string): string {
    return this.configService.getConfig().apiUrl + appRelativeEndpoint;
  }

  protected handleError(error: HttpErrorResponse | any) {
    let err;
    if (error instanceof HttpErrorResponse) {
      err = error || {};
    } else {
      err = new HttpErrorResponse(error);
    }
    return observableThrowError(err);
  }

}
